import ApiService from 'Services/ApiService'

export default {
    list() {
        return ApiService.get('offices')
    },
    listExternal() {
        return ApiService.get('offices/fetch-from-portal')
    },
    get(id) {
        return ApiService.get(`offices/${id}`, {
            params
        })
    },
    store(office) {
        return ApiService.post('offices', office)
    },
    update(id, office) {
        return ApiService.put(`offices/${office.id}`, office)
    },
    delete(id) {
        return ApiService.delete(`offices/${id}`)
    }
}